/**
 * The Compare / trade-list variant a My Pokémon RECORD offers as
 * (2026-09-29): the friend trade list is species-level (species, variant,
 * direction), so a listed record has to be named by its strongest variant,
 * in the order the Compare tiles rank them.
 */
import type { CompareVariant } from "@/components/trade/compareTypes";
import type { MyPokemonRecord } from "./myPokemonStore";

export function recordCompareVariant(r: MyPokemonRecord): CompareVariant {
  if (r.isShiny && r.isLucky) return "shinyLucky";
  if (r.isShiny) return "shiny";
  if (r.isLucky) return "lucky";
  if (r.ivAtk === 15 && r.ivDef === 15 && r.ivHp === 15) return "perfect";
  if (r.isGmax) return "gmax";
  if (r.isDynamax) return "dynamax";
  if (r.isShadow) return "shadow";
  if (r.isPurified) return "purified";
  if (r.sizeClass === "xxl") return "xxl";
  if (r.sizeClass === "xxs") return "xxs";
  return "pokemon";
}
